import React from "react";
import ServicesList from "components/backend/listings/services/index";

export default class ServicesArchive extends React.Component {
  render() {
    return <ServicesList status="archived" {...this.props} />;
  }
}
